import { render, staticRenderFns } from "./AditionalItem.vue?vue&type=template&id=52159a5e&scoped=true"
import script from "./AditionalItem.vue?vue&type=script&lang=js"
export * from "./AditionalItem.vue?vue&type=script&lang=js"
import style0 from "./AditionalItem.vue?vue&type=style&index=0&id=52159a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52159a5e",
  null
  
)

export default component.exports